import { useEffect, useMemo } from "react";
import {
  useProductsOverviewActions,
  useProductsOverviewStore,
} from "stores/productsOverviewStore";
import { useProject } from "stores/project";
import { useUser } from "stores/user";
import { filterProductListByMandator } from "./utils/filterProductListByMandator";
import { useIsSameProj, useLanguage } from "stores/globalStore";

export const useAllProducts = () => {
  const user = useUser();

  const isSameProj = useIsSameProj();
  const lang = useLanguage();
  const project = useProject();

  const allProducts = useProductsOverviewStore((state) => state.allProducts);
  const { getProductsData } = useProductsOverviewActions();

  useEffect(() => {
    if (user) {
      getProductsData({ lang, currentUserTenant: user.tenant });
    }
  }, [getProductsData, lang, user]);

  const list = useMemo(() => {
    if (!isSameProj || !project?.mandator || !user?.tenant) {
      return allProducts;
    }
    return filterProductListByMandator(
      allProducts,
      project.mandator,
      user?.tenant,
    );
  }, [isSameProj, project, user, allProducts]);

  return list;
};
